import { styled } from "theme/default/styled";
import { setColor_rgba_0_0_0_4 } from "theme/setter/setOpacityColorsValues/setColor_rgba_0_0_0_4";

export const SDetailsLayoutDivider = styled.div`
  margin: 0 3px;

  ${setColor_rgba_0_0_0_4};
`;
